/** Readers for weather content (or its card), shared by the frame and its card preview. */

/**
 * Accept numbers or agent-typed strings ("19", "19°", "19°C").
 * Returns null when no temperature can be read so the caller can
 * fall back instead of rendering a bogus 0°.
 */
export function parseTemp(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.round(value);
  }
  if (typeof value === "string") {
    const match = value.match(/-?\d+(\.\d+)?/);
    if (match) {
      const parsed = Number(match[0]);
      if (Number.isFinite(parsed)) return Math.round(parsed);
    }
  }
  return null;
}

/** A trimmed, non-empty label (place, condition), else null. */
export function parseLabel(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}
